import request from '@/utils/request'
import APIS from '@/permissions/index'
// 分页查询回款记录
export function queryTaxIncome (params) {
  return request({
    ...APIS['@vocherIncome/Query_Tax_Income'],
    params
  })
}

export function queryConsumeRecord (params) {
  return request({
    ...APIS['@vocherIncome/Query_Consume_Record'],
    params
  })
}

export function updateTaxIncome (data) {
  return request({
    ...APIS['@vocherIncome/Update_TaxIncome'],
    data
  })
}

export function deleteTaxIncome (params) {
  return request({
    ...APIS['@vocherIncome/Delete_TaxIncome'],
    params
  })
}
export function updateConsumeRecord (data) {
  return request({
    ...APIS['@vocherIncome/Update_ConsumeRecord'],
    data
  })
}
export function importTaxIncome (data) {
  return request({
    ...APIS['@vocherIncome/Import_TaxIncome'],
    data
    // timeout: 300000
  })
}

export function importConsumeRecord (data) {
  return request({
    ...APIS['@vocherIncome/Import_ConsumeRecord'],
    data
    // timeout: 300000
  })
}

export function exportTaxIncome (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@vocherIncome/Export_TaxIncome'],
    params,
    headers,
    responseType
  })
}

export function exportConsumeRecord (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@vocherIncome/Export_ConsumeRecord'],
    params,
    headers,
    responseType
  })
}

export function addTaxIncome (data) {
  return request({
    ...APIS['@vocherIncome/Add_TaxIncome'],
    data
  })
}

export function importTaxIncomeProgress (params) {
  return request({
    ...APIS['@vocherIncome/Import_TaxIncomeProgress'],
    params
  })
}

export function importConsumeRecordProgress (params) {
  return request({
    ...APIS['@vocherIncome/Import_ConsumeRecordProgress'],
    params
  })
}
